<path
    fill="currentColor"
    d="M22.6787 30.667h-13.36c-4.4 0-7.98667-3.5866-7.98667-7.9866 0-.7334.6-1.3334 1.33333-1.3334.73334 0 1.33334.6 1.33334 1.3334 0 2.9333 2.38666 5.32 5.32 5.32H22.692c2.9334 0 5.32-2.3867 5.32-5.32V11.3337c0-1.41332-.5466-2.75999-1.56-3.75999-.52-.52-.52-1.36 0-1.88.52-.52 1.36-.52 1.88 0 1.5067 1.49333 2.3334 3.50667 2.3334 5.63999v11.36c0 4.3867-3.5867 7.9733-7.9867 7.9733Z"
/><path
    fill="currentColor"
    d="M2.66536 19.3335c-.73333 0-1.33333-.6-1.33333-1.3333v-6.68c0-4.40004 3.58667-7.9867 7.98667-7.9867H22.692c2.1334 0 4.1334.82666 5.64 2.33333.52.52.52 1.36 0 1.88-.52.52-1.36.52-1.88 0-1.0133-1-2.3466-1.54667-3.7733-1.54667h-13.36c-2.93334 0-5.32 2.38667-5.32 5.32004v6.68c0 .7333-.6 1.3333-1.33334 1.3333Z"
/><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-width="2.4"
    d="m13.9277 12.2983 6.3519 3.176c.9827.4913.9827 1.8937 0 2.3851l-6.3519 3.176c-.8866.4432-1.9297-.2014-1.9297-1.1926v-6.3519c0-.9912 1.0431-1.6359 1.9297-1.1926Z"
/>
